import Axios from '../axios.js';

// 查看申报信息
export const getDeclareApplication = (id) => {
    return Axios({
        url: `/api/admin/declare/getDeclareApplication/${id}`,
        method: 'get',
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

// 获取申报列表
export const getDeclareList = (params) => {
    return Axios({
        url: `/api/admin/declare`,
        method: 'get',
        params
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

// 编辑申报
export const putDeclare = (data) => {
    return Axios({
        url: `/api/admin/declare/putDeclare/${data.id}`,
        method: 'put',
        data
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

//新增申报
export const postDeclare = (data) => {
    return Axios({
        url: `/api/admin/declare/postDeclare`,
        method: 'post',
        data
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

// 删除申报
export const deleteDeclare = (id) => {
    return Axios({
        url: `/api/admin/declare/deleteDeclare/${id}`,
        method: 'delete',
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

// 申报详情
export const getDeclare = (id) => {
    return Axios({
        url: `/api/admin/declare/getDeclare/${id}`,
        method: 'get',
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

// 申报记录列表
export const getApplicationList = (params) => {
    return Axios({
        url: `/api/admin/declare/listApplication`,
        method: 'get',
        params
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

// 评选
export const updateDeclareApplication = (data) => {
    return Axios({
        url: `/api/admin/declare/updateDeclareApplication/${data.id}`,
        method: 'put',
        params:data
    }).then(
        res => Promise.resolve(res.data),
        err => Promise.reject(err)
    );
}

export default {
    getDeclareApplication,
    getDeclareList,
    putDeclare,
    postDeclare,
    deleteDeclare,
    getDeclare,
    getApplicationList,
    updateDeclareApplication
}
